import { Text } from '@dixa/lib-shared-habla';

export function RoutedThroughStop(): JSX.Element {
  return (
    <Text.Paragraph>Stop · Automation visited the stop action</Text.Paragraph>
  );
}
